module.exports = __webpack_public_path__ + "static/media/left-arrow.69bb73dd.svg";